<template>
  <div class="about">
    <b-container>
      <br><br>
      <b-jumbotron header="Karriere bei EZW Werkzeugbau"></b-jumbotron>
      <br>
      <div id="jobs">
        <b-card no-body>
          <b-tabs pills card :vertical="vertical" :nav-wrapper-class="wrapper">
            <b-tab v-for="(job, index) in visibleRows()" :key="index" :title="job.title">
              <b-card-text>
                <h2>{{job.header}}</h2><br>
                <span v-for="(row, index) in job.rows" :key="index">{{row}}<br><br></span>
                <h4><b>Deine Aufgaben</b></h4>
                <div class="list">
                  <table>
                    <tr v-for="(item, index) in job.tasks" :key="index">
                      <td class="icon"><b-icon icon="arrow-right-circle-fill"></b-icon></td><td>{{item}}</td>
                    </tr>
                  </table>
                </div><br><br>
                <h4><b>Deine Qualifikation</b></h4>
                <div class="list">
                  <table>
                    <tr v-for="(item, index) in job.qualifications" :key="index">
                      <td class="icon"><b-icon icon="arrow-right-circle-fill"></b-icon></td><td>{{item}}</td>
                    </tr>
                  </table>
                </div><br><br>
                <h4><b>Unser Angebot</b></h4>
                <div class="list">
                  <table>
                    <tr v-for="(item, index) in job.offers" :key="index">
                      <td class="icon"><b-icon icon="arrow-right-circle-fill"></b-icon></td><td>{{item}}</td>
                    </tr>
                  </table>
                </div>
                <br>
                <b v-html="job.infoHead"></b><br>
                <div v-html="job.info"></div>
              </b-card-text>
            </b-tab>
            <b-tab title="Initiativbewerbung">
              <b-card-text>
                <h2>Initiativbewerbung</h2><br><br>
                <div v-if="visibleRows().length > 0">
                  Keine Stelle für dich dabei?<br>
                  Dann melde dich auch gerne mit deiner Initiativbewerbung bei uns.
                </div>
                <div v-else>
                  Leider bieten wir aktuell keine bestimmte Stelle an.<br>
                  Du kannst dich allerdings trotzdem gern mit deiner Initiativbewerbung bei uns melden.
                </div>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </b-container>
    <div class="spacer"></div>
  </div>
</template>

<script>
import axios from 'axios'
  export default {
    data() {
      return {
        data: {},
        vertical: true,
        wrapper: 'w-25'
      }
    },
    created() {
      window.addEventListener("resize", this.changeVertical);
      this.changeVertical();
    },
    destroyed() {
      window.removeEventListener("resize", this.changeVertical);
    },
    mounted() {
        axios.get('/konfiguration/karriere.json').then((response) => {
            this.data = response.data
        }).catch((err)=>{this.test=err;console.log(err)});
    },
    methods: {
      changeVertical: function() {
        this.vertical = window.innerWidth > 996;
        if(this.vertical) {
          this.wrapper = 'w-25'
        } else {
          this.wrapper = false
        }
      },
      visibleRows: function () {
        return this.data.jobs.filter(function(job) {return job.visible == true;});
      }
    }
  }
</script>

<style scoped>
td {
  line-height: 110%;
  vertical-align: text-top;
  padding-bottom: 5px;
}

.list {
  padding-left: 3%;
}

.icon {
  padding-right: 7px;
}

.jumbotron {
  background-color: #656565;
  color: white;
}

@media only screen and (max-width: 500px) {
  .jumbotron .display-3 {
    font-size: 3.5rem!important;
  }
}

@media only screen and (max-width: 350px) {
  .jumbotron .display-3 {
    font-size: 2.5rem!important;
  }
}

.spacer {
    height: 50px;
    width: 100%;
}

.card {
  height: 60vh;
}

* >>>.tabs {
  height: 100%;
}

* >>>.tab-content {
  height: 100%;
  overflow: scroll!important;
}

* >>>.card-header {
  position: relative;
  z-index: 1;
}

@media only screen and (max-width: 576px) {
  .card {
    border-left: none;
    border-right: none;
    border-top: none;
    border-radius: 0;
  }

  * >>>.card-header:first-child {
    border-radius: 0;
  }

  .jumbotron {
    border-radius: 0px!important;
  }
}

@media only screen and (max-width: 996px) {
  * >>>.nav-pills {
    overflow: scroll;
    flex-wrap: nowrap;
  }

  .card {
    height: 56vh;
  }

  * >>>.tab-content {
    margin-top: -69px;
    padding-top: 69px;
    overflow: scroll!important;
    z-index: -1;
  }

  * >>>.tab-content .active {
    position: relative;
    z-index: 0;
  }

  * >>> .nav-link {
    background-color: #007bff!important;
    color: white!important;
    border: 2px solid white;
    margin: 0 5px 0 0!important;
  }  
}

.tabs .col-auto {
  height: 60vh!important;
}

* >>>.col-auto {
  height: 60vh!important;
  overflow: scroll;
  background-color: #007bff;
}

* >>>.card-header {
  background-color: #007bff;
  border-radius: 0px;
}

* >>> .h-100 {
  min-height: 60vh;
  height: auto!important;
}

* >>> .nav-pills {
  background-color: rgba(255, 255, 255, 0)!important;
}

* >>> .nav-link.active {
  background-color: white!important;
  color: #007bff!important;
}

* >>> .nav-link {
  background-color: #007bff!important;
  color: white!important;
  border: 2px solid white;
  margin: 0 0 5px 0;
}

* >>> .nav-link:hover {
  background-color: white!important;
  color: #007bff!important;
}

.container {
  padding: 0;
}

h1 {
  text-align: center;
}

.btn {
  height: 100%;
  background-color: #007bff;
  border: none;
}
</style>